module.exports = __webpack_public_path__ + "img/Equatorial-Guinea.1e230e18.png";